<mat-form-field>
  <mat-label>Land</mat-label>
  <mat-select #input=ngModel
              [(ngModel)]="model">
    @for (code of countryCodes; track code) {
      <mat-option [value]="code">+{{ code }}</mat-option>
    }
  </mat-select>
</mat-form-field>